<template>
  <div>
    车辆诊断管理
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
